import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { Button, DialogActions } from '@mui/material'

import type { ImportProgress } from '@/features/sqlImport/types'
import { useAppContext } from '@/hooks'

interface ImportDialogActionsProps {
	errors: {
		selectedFile?: { message?: string }
		sqlText?: { message?: string }
	},
	inputMode: 'file' | 'paste'
	onClose: () => void,
	onResetProgress: () => void,
	onSubmit: () => Promise<void>,
	progress: ImportProgress,
	selectedFile: File | null,
	sqlText: string
}

export const ImportDialogActions = ({
	progress,
	inputMode,
	selectedFile,
	sqlText,
	errors,
	onSubmit,
	onClose,
	onResetProgress,
}: ImportDialogActionsProps) => {
	const { t } = useAppContext()

	return (
		<DialogActions>
			{progress.status === 'idle' && (
				<>
					<Button
						onClick={onSubmit}
						disabled={
							inputMode === 'file'
								? !selectedFile || !!errors.selectedFile
								: !sqlText.trim() || !!errors.sqlText
						}
						variant="contained"
						startIcon={<CloudUploadIcon />}
					>
						{t('IMPORT_SQL')}
					</Button>
					<Button onClick={onClose}>{t('CANCEL')}</Button>
				</>
			)}

			{progress.status === 'importing' && (
				<Button disabled>{t('IMPORT_SQL_UPLOADING')}</Button>
			)}

			{(progress.status === 'success' || progress.status === 'error') && (
				<>
					{progress.status === 'error' && (
						<Button onClick={onResetProgress}>{t('TRY_AGAIN')}</Button>
					)}
					<Button onClick={onClose} variant="contained">
						{t('CLOSE')}
					</Button>
				</>
			)}
		</DialogActions>
	)
}

